export default "__VITE_ASSET__CkvSm_yQ__"